import React, { useEffect, useState, useRef } from "react";
import {
    Typography,
    Button,
    Input,
    IconButton,
    Tooltip
} from "@material-tailwind/react";
import Swal from "sweetalert2";
import Toaster from "../../components/Toaster";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover, PopoverContent } from 'react-tiny-popover';
import ShowLoader from "@/components/Loader";
import useHasPermission from "../../components/useHasPermission";
import {
    Bars3BottomLeftIcon,
    ChevronDownIcon,
    MagnifyingGlassIcon,
    XCircleIcon,
    InformationCircleIcon,
    ClockIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    CalendarDaysIcon,
    ArchiveBoxIcon,
} from "@heroicons/react/24/solid";
import { approveRfq, deleteRfq, getRfqs, bulkActionRfq, setEmptySalesTeamMember, clearRfqs, toggleArchiveRfq, approvePOAcknowledgement, ejectRfq } from "../../store/slices/rfqSlice";
import ScrollToTop from "@/components/ScrollToTop";
import AssignSalesManagerModal from "./rfq-modals/assign-rfq-to-sales-modal";
import RfqTypeSelector from "./rfq-type-selector";
import TimeLineModal from "./rfq-modals/timeline-modal";
import moment from "moment";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from "react-i18next";
import { CheckBadgeIcon, DocumentArrowDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import DocumentViewModal from "@/components/DocumentViewModal";


export function Rfq() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const { t } = useTranslation('rfq');
    const { t: ct } = useTranslation("common");

    const sorting_options = [
        { label: t('sort_ascending'), value: 'asc' },
        { label: t('sort_descending'), value: 'desc' },
    ];

    // Selectors
    const { user } = useSelector((state) => state.user);
    const { list_rfqs, loading, list_loading, hasMore, total_count, owner_counts, my_status_counts, unread_counts, unread_type_counts } = useSelector((state) => state.rfq);

    const hasUnreadNormal = Number(unread_type_counts?.normal) > 0;
    const hasUnreadCustom = Number(unread_type_counts?.custom) > 0;

    // State
    const [search, setSearch] = useState('');
    const [sortingOrder, setSortingOrder] = useState('');
    const [isSortingPopoverOpen, setIsSortingPopoverOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState("normal");
    const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
    const [isTimelineModalOpen, setIsTimelineModalOpen] = useState(false);
    const [checkedAction, setCheckedAction] = useState('');
    const [checkedItems, setCheckedItems] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [filter, setFilter] = useState(null);
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [isSpinning1, setIsSpinning1] = useState(false);
    const [isSpinning2, setIsSpinning2] = useState(false);

    const hasUpdatePermission = useHasPermission(`rfq.update`);
    const hasDeletePermission = useHasPermission(`rfq.delete`);

    const action_options = (hasDeletePermission && (filter === 'archived' || filter === 'bin'))
        ? [{ label: t("delete_action"), value: 'delete' }]
        : [];

    const [quotationStatus, setQuotationStatus] = useState("");
    const [isQuotationPopoverOpen, setIsQuotationPopoverOpen] = useState(false);

    const [currentOwnerFilter, setCurrentOwnerFilter] = useState('');

    const quotationOptions = [
        {
            label: t("all_quotations_filter"),
            value: ""
        },
        {
            label: t("approved_by_client_filter"),
            value: "approved"
        },
        {
            label: t("rejected_by_client_filter"),
            value: "rejected"
        },
        {
            label: t("approved_with_po_filter"),
            value: "approved_with_po"
        },
        {
            label: t("approved_without_po_filter"),
            value: "approved_without_po"
        },
    ];

    const [tabs, setTabs] = useState([]);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [myStatusFilter, setMyStatusFilter] = useState("");
    const myStatusOptions = [
        { label: t("pending_with_you_filter"), value: "pending" },
        { label: t("done_from_your_side_filter"), value: "done" },
        { label: t("rejected_filter"), value: "rejected" },
    ];

    const getSortButtonLabel = () => {
        if (myStatusFilter) {
            return myStatusOptions.find(o => o.value === myStatusFilter)?.label;
        }
        if (sortingOrder) {
            return sorting_options.find(o => o.value === sortingOrder)?.label;
        }
        return t("sort_latest");
    };

    // Permissions and Initial Setup
    useEffect(() => {
        // Initialize tabs with translated labels
        const initialTabs = [
            { id: "assigned", label: t("approved_tab") },
            { id: "pending_po_acknowledgement", label: t("pending_po_acknowledgement_tab") },
            { id: "rejected_orders", label: t("rejected_by_finances_tab") },
        ];

        const active_filter = searchParams.get("filter");
        const active_tab = searchParams.get("activeTab");

        // if (user?.roles?.[0] !== 'Finance') {
        //     setTabs(prev => {
        //         if (!prev.find(t => t.id === "pending_for_approval")) {
        //             return [{ id: "pending_for_approval", label: "Assigned / Approval Pending" }, ...prev];
        //         }
        //         return prev;
        //     });
        // }

        // if (user?.roles?.[0] !== 'Finance') {
        //     setTabs(prev => {
        //         let updatedTabs = [...prev];
        //         if (!updatedTabs.find(t => t.id === "pending_for_approval")) {
        //             updatedTabs.unshift({ id: "pending_for_approval", label: "Assigned / Approval Pending" });
        //         }
        //         if (!updatedTabs.find(t => t.id === "reassigned")) {
        //             updatedTabs.push({ id: "reassigned", label: "Reassigned" });
        //         }
        //         return updatedTabs;
        //     });
        // }

        setTabs(prev => {
            let updatedTabs = [...initialTabs];

            // Pending Approval tab only for non-finance
            if (
                user?.roles?.[0] !== 'Finance' &&
                !updatedTabs.find(t => t.id === "pending_for_approval")
            ) {
                updatedTabs.unshift({
                    id: "pending_for_approval",
                    label: t("pending_approval_tab")
                });
            }

            // Reassigned tab for everyone including Finance
            if (!updatedTabs.find(t => t.id === "reassigned")) {
                updatedTabs.push({
                    id: "reassigned",
                    label: t("reassigned_tab")
                });
            }

            return updatedTabs;
        });

        if (user?.roles?.[0] !== 'Sales Representative' && user?.roles?.[0] !== 'Finance' && user?.roles?.[0] !== 'Procurement') {
            setTabs(prev => {
                // if (!prev.find(t => t.id === "unassigned")) {
                //     return [{ id: "unassigned", label: t("unassigned_tab") }, ...prev];
                // }
                // return prev;
                let updatedTabs = [...prev];
                if (!updatedTabs.find(t => t.id === "unassigned")) {
                    updatedTabs.unshift({ id: "unassigned", label: t("unassigned_tab") });
                }
                if (!updatedTabs.find(t => t.id === "archived")) {
                    updatedTabs.push({ id: "archived", label: t("archived_tab") });
                }
                if (!updatedTabs.find(t => t.id === "bin")) {
                    updatedTabs.push({ id: "bin", label: t("bin_tab", "Bin") });
                }
                return updatedTabs;
            });
            setFilter(active_filter || 'unassigned');
        } else {
            if (user?.roles?.[0] === 'Finance') {
                setFilter(active_filter || 'assigned');
            } else {
                setFilter(active_filter || 'pending_for_approval');
            }
        }

        setActiveTab(active_tab || 'normal');

    }, [user, t]);

    // MAIN DATA FETCHING LOGIC
    // We consolidate the API call into one function that triggers when dependencies change
    const loadData = (pageNumber = 1, isAppend = false) => {
        dispatch(getRfqs({
            activetab: activeTab,
            page: pageNumber,
            perPage: itemsPerPage,
            search: search,
            filter: filter,
            sort_order: sortingOrder,
            status: statusFilter,
            start_date: startDate,
            end_date: endDate,
            quotation_status: quotationStatus,
            current_owner: currentOwnerFilter,
            my_status: myStatusFilter,
        }));
    };

    // Trigger on structural changes (Tab, Filter, Sort, Status)
    useEffect(() => {
        if (!filter) return;

        setCurrentPage(1);
        setCheckedItems([]);
        dispatch(clearRfqs());
        let params = {};
        params.filter = filter;
        params.activeTab = activeTab;
        setSearchParams(params, { replace: true });
        loadData(1);
    }, [activeTab, filter, sortingOrder, statusFilter, startDate, endDate, quotationStatus, currentOwnerFilter, myStatusFilter]);

    // Handlers
    const handelSearch = (event) => {
        if (event.key === "Enter") {
            setCurrentPage(1);
            loadData(1);
        } else if (event.key === "Backspace" && search.length === 0) {
            setCurrentPage(1);
            loadData(1);
        }
    };

    const handleSearchClick = () => {
        setCurrentPage(1);
        loadData(1);
    };

    const handelRemoveSearch = () => {
        setSearch('');
        setCurrentPage(1);
        dispatch(getRfqs({
            activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', filter, sort_order: sortingOrder, status: statusFilter, start_date: startDate, end_date: endDate
        }));
    };

    const handelSorting = (value) => {
        setSortingOrder(value);
        setIsSortingPopoverOpen(false);
    };

    const fetchMoreData = () => {
        const nextPage = currentPage + 1;
        dispatch(getRfqs({
            activetab: activeTab,
            page: nextPage,
            perPage: itemsPerPage,
            search: search,
            filter: filter,
            sort_order: sortingOrder,
            status: statusFilter,
            start_date: startDate,
            end_date: endDate,
            quotation_status: quotationStatus,
            current_owner: currentOwnerFilter
        })).unwrap().then(() => {
            setCurrentPage(nextPage);
        });
    };

    const forceReloadRfq = () => {
        setIsSpinning1(true);
        setSearch('');
        setCurrentPage(1);
        setCurrentOwnerFilter('');
        dispatch(getRfqs({ activetab: activeTab, page: 1, perPage: itemsPerPage, search: '', filter, sort_order: '', status: '', start_date: '', end_date: '', current_owner: '' }))
            .finally(() => setTimeout(() => setIsSpinning1(false), 1000));
    };

    const reloadRfq = () => {
        setIsSpinning2(true);
        loadData(currentPage);
        setTimeout(() => setIsSpinning2(false), 1000);
    };

    const handelCheckedItems = (action) => {
        setCheckedAction(action);
        setIsCheckedItemPopoverOpen(false);
        if (checkedItems.length > 0) {
            Swal.fire({
                title: ct("areYouSure"),
                text: t("performActionConfirmation"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes"
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(bulkActionRfq({ action: action, rfq_ids: checkedItems })).unwrap().then(() => {
                        Toaster.success(t('actionCompletedSuccess', { action: action }));
                        setCheckedItems([]);
                        loadData(1);
                    }).catch(() => Toaster.error(ct("actionFailed")));
                }
            });
        } else {
            Toaster.error(t("selectItemsFirst"));
        }
    };

    const handleSingleCheck = (id) => {
        setCheckedItems(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckedItems(list_rfqs?.map(row => row.id) || []);
        } else {
            setCheckedItems([]);
        }
    };

    const [isSetPOFile, setPOFile] = useState(false);
    const [openPOPopoverId, setOpenPOPopoverId] = useState(null);

    const handlePOAcknowledgement = (id, status) => {
        // Reject Flow
        if (status === "no") {
            Swal.fire({
                title: t("reject_po_title"),
                text: t("reject_po_confirmation"),
                icon: "warning",
                input: "textarea",
                inputLabel: t("rejection_reason_label"),
                inputPlaceholder: t("enter_rejection_reason_placeholder"),
                inputAttributes: {
                    maxlength: 500,
                    rows: 4,
                },
                showCancelButton: true,
                confirmButtonColor: "#dc2626",
                cancelButtonColor: "#6b7280",
                confirmButtonText: ct("reject"),
                cancelButtonText: ct("cancel"),
                inputValidator: (value) => {
                    if (!value || !value.trim()) {
                        return t("rejection_reason_required_for_po");
                    }
                    if (value.trim().length < 10) {
                        return t("reason_min_chars");
                    }
                    if (value.trim().length > 100) {
                        return t("reason_max_chars");
                    }
                    return null;
                },
            }).then((result) => {
                if (!result.isConfirmed) return;

                dispatch(
                    approvePOAcknowledgement({
                        rfq_id: id,
                        is_po_approved: status,
                        rejection_reason: result.value.trim(),
                    })
                )
                    .unwrap()
                    .then(() => {
                        Toaster.success(t("po_rejected_success"));
                        loadData(1);
                    })
                    .catch(() => {
                        Toaster.error(ct("actionFailed"));
                    });
            });

            return;
        }

        // Approve Flow
        Swal.fire({
            title: t("approve_po_title"),
            text: t("approve_po_confirmation"),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#16a34a",
            cancelButtonColor: "#6b7280",
            confirmButtonText: ct("approve"),
            cancelButtonText: ct("cancel"),
        }).then((result) => {
            if (!result.isConfirmed) return;

            dispatch(
                approvePOAcknowledgement({
                    rfq_id: id,
                    is_po_approved: status,
                })
            )
                .unwrap()
                .then(() => {
                    Toaster.success(t("po_approved_success"));
                    loadData(1);
                })
                .catch(() => {
                    Toaster.error(ct("actionFailed"));
                });
        });
    };
    const formatReceivedRfqDate = (dateStr) => {
        if (!dateStr) return t("na");
        const date = moment(dateStr);
        return date.isSame(moment(), "day") ? `${t("today_date")} | ${date.format("h:mm A")}` : date.format("D MMM | h:mm A");
    };

    const isAllChecked = list_rfqs?.length > 0 && checkedItems.length === list_rfqs?.length;

    const getTimeSlotStatus = (toTime) => {
        if (!toTime) return { color: "text-gray-500", text: t("na"), delayed: "" };

        const now = moment();
        const end = moment(toTime);
        const isDelayed = now.isAfter(end);

        let delayedText = "";
        if (isDelayed) {
            const days = now.diff(end, 'days');
            const hours = now.diff(end, 'hours') % 24;

            if (days > 0) {
                delayedText = ` (${days} ${days === 1 ? t("day_delayed") : t("days_delayed")})`;
            } else if (hours > 0) {
                delayedText = ` (${hours} ${hours === 1 ? t("hour_delayed") : t("hours_delayed")})`;
            } else {
                delayedText = ` (${t("delayed")})`;
            }
        }

        return {
            color: isDelayed ? "text-red-500" : "text-green-500",
            delayed: delayedText
        };
    };

    const [isStatusPopoverOpen, setIsStatusPopoverOpen] = useState(false);


    const isManagerDesignation = (assignedUser) => {
        return assignedUser?.designation?.toLowerCase() === "manager";
    };

    const getActivePendingUsers = (users = [], type, rfq = {}) => {
        if (!users.length) return [];

        const managers = users.filter(isManagerDesignation);
        const members = users.filter(item => !isManagerDesignation(item));

        if (type === "sales") {
            if (rfq?.is_send_to_sales != null || rfq?.sales_representative_approval != null || !members.length) {
                return managers.length ? managers : users;
            }

            return members;
        }

        if (type === "procurement") {
            if (rfq?.admin_approval === "no") {
                return members.length ? members : managers.length ? managers : users;
            }

            if (rfq?.is_send_to_procurement != null || rfq?.procurement_manager_approval != null || !members.length) {
                return managers.length ? managers : users;
            }

            return members;
        }

        return users;
    };

    const generateProcessSteps = (assigned_details, currentStep, rfq = {}) => {
        const getAssignedNames = (roleType, activeOnly = false) => {
            const users = (assigned_details || []).filter(item => item.type === roleType);
            const activeUsers = activeOnly
                ? getActivePendingUsers(
                    users,
                    roleType === "Sales Representative" ? "sales" : roleType?.toLowerCase(),
                    rfq
                )
                : users;

            if (activeUsers.length === 0) return t("the_team_fallback");

            // Add the designation in brackets next to the name
            return activeUsers.map(user =>
                user.designation ? `${user.assigned_to_name} (${user.designation})` : user.assigned_to_name
            ).join(" and ");
        };

        const checkIfDelayed = (roleType) => {
            const users = (assigned_details || []).filter(item => item.type === roleType);
            if (users.length === 0) return false;

            const now = new Date();
            return users.some(user => {
                if (!user.timeslot || !user.timeslot.to) return false;
                // Using 'T' ensures accurate parsing across all browsers
                const deadlineDate = new Date(user.timeslot.to.replace(' ', 'T'));
                return now > deadlineDate;
            });
        };

        const salesNames = getAssignedNames("Sales Representative");
        const procurementNames = getAssignedNames("Procurement");
        const adminNames = getAssignedNames("Admin"); // Update this if your role is "Administrator"
        const activeSalesNames = getAssignedNames("Sales Representative", true);
        const activeProcurementNames = getAssignedNames("Procurement", true);

        // Map your currentStep to our completion logic
        const isSalesCompleted = currentStep > 1;
        const isProcurementCompleted = currentStep > 2;
        const isAdminCompleted = currentStep > 3;

        return [
            {
                title: t("sales_process_title"),
                status: isSalesCompleted ? "completed" : (checkIfDelayed("Sales Representative") ? "delayed" : "pending"),
                completed_description: t("sales_completed_desc", { salesNames }),
                pending_description: t("sales_pending_desc", { salesNames: activeSalesNames }),
                delayed_description: t("sales_delayed_desc", { salesNames: activeSalesNames }),
            },
            {
                title: t("procurement_process_title"),
                status: isProcurementCompleted ? "completed" : (checkIfDelayed("Procurement") ? "delayed" : "pending"),
                completed_description: t("procurement_completed_desc", { procurementNames }),
                pending_description: t("procurement_pending_desc", { procurementNames: activeProcurementNames }),
                delayed_description: t("procurement_delayed_desc", { procurementNames: activeProcurementNames }),
            },
            {
                title: t("admin_approval_process_title"),
                status: isAdminCompleted ? "completed" : (checkIfDelayed("Admin") ? "delayed" : "pending"),
                completed_description: t("admin_completed_desc", { adminNames: adminNames === t("the_team_fallback") ? t("administrator_fallback") : adminNames }),
                pending_description: t("admin_pending_desc", { adminNames: adminNames === t("the_team_fallback") ? t("administrator_fallback") : adminNames }),
                delayed_description: t("admin_delayed_desc"),
            },
        ];
    };

    const userRole = user?.roles?.[0];
    const ownerCards = [
        {
            key: "sales",
            label: t("pending_with_sales_label"),
            count: owner_counts?.sales || 0,
            icon: "👤",
            bg: "bg-blue-50",
            text: "text-blue-700",
            border: "border-blue-200",
        },
        {
            key: "procurement",
            label: t("pending_with_procurement_label"),
            count: owner_counts?.procurement || 0,
            icon: "📦",
            bg: "bg-purple-50",
            text: "text-purple-700",
            border: "border-purple-200",
        },
        {
            key: "admin",
            label: t("pending_with_admin_label"),
            count: owner_counts?.admin || 0,
            icon: "🛡️",
            bg: "bg-indigo-50",
            text: "text-indigo-700",
            border: "border-indigo-200",
        },
    ].filter((card) => {
        // if (userRole === "Sales") {
        //     return card.key === "sales";
        // }

        // if (userRole === "Procurement") {
        //     return card.key === "procurement";
        // }

        if (userRole === "Administrator" || userRole === "Sub Admin") {
            return true;
        }
        // Admin and all other roles
        return false;
    });

    const getCurrentStep = (rfq) => {
        // Step 4 - Admin completed
        if (rfq?.admin_approval === "yes") {
            return 4;
        }

        // Step 3 - Pending with Admin
        if (rfq?.is_send_to_admin) {
            return 3;
        }

        // Step 2 - Pending with Procurement
        // const hasProcurement = rfq?.assigned_details?.some(
        //     item => item.type === "Procurement"
        // );
        // console.log(rfq);
        // if (hasProcurement) {
        //     return 2;
        // }
        if (rfq?.is_procurement_assigned === 'yes') {
            return 2;
        }

        // Step 1 - Pending with Sales
        return 1;
    };
    const isWorkflowRejected = (rfq) => {
        return rfq?.admin_approval === "no" ||
            rfq?.sales_representative_approval === "no" ||
            rfq?.procurement_manager_approval === "no";
    };
    const statusColors = {
        sales: "bg-blue-100 text-blue-700",
        procurement: "bg-purple-100 text-purple-700",
        admin: "bg-indigo-100 text-indigo-700",
        completed: "bg-green-100 text-green-700",
        rejected: "bg-red-100 text-red-700",
    };
    const workflowStepColors = {
        sales: "bg-blue-500",
        procurement: "bg-purple-500",
        admin: "bg-indigo-500",
        completed: "bg-green-500",
        delayed: "bg-red-500",
        pending: "bg-gray-300",
    };

    const workflowTextColors = {
        sales: "text-blue-600",
        procurement: "text-purple-600",
        admin: "text-indigo-600",
        completed: "text-green-600",
        delayed: "text-red-600",
    };

    const handleArchiveRfq = (rfqId, archiveValue) => {
        Swal.fire({
            title: ct("areYouSure"),
            text: archiveValue === "yes" ? t("archive_rfq_confirmation") : t("unarchive_rfq_confirmation"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: ct("yes_button_text"),
            cancelButtonText: ct("cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(toggleArchiveRfq({ rfq_id: rfqId, is_archived: archiveValue }))
                    .unwrap()
                    .then((res) => {
                        // Toaster.success(res?.message || (archiveValue === "yes" ? t("archive_rfq_success") : t("unarchive_rfq_success")));
                        Toaster.success(archiveValue === "yes" ? t("archive_rfq_success") : t("unarchive_rfq_success"));
                        loadData(1);
                    })
                    .catch((err) => {
                        Toaster.error(err?.message || t('archive_rfq_failed'));
                    });
            }
        });
    };

    const handleEjectRfq = (rfqId) => {
        Swal.fire({
            title: t("move_to_bin_title"),
            text: t("move_to_bin_confirmation"),
            icon: "warning",
            input: "textarea",
            inputLabel: t("move_to_bin_reason_label"),
            inputPlaceholder: t("move_to_bin_reason_placeholder"),
            inputAttributes: {
                maxlength: 250,
                rows: 4,
            },
            showCancelButton: true,
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: t("move_to_bin_button"),
            cancelButtonText: ct("cancel"),
            inputValidator: (value) => {
                const reason = (value || "").trim();
                if (!reason) return t("move_to_bin_reason_required");
                if (reason.length < 5) return t("move_to_bin_reason_min_chars");
                if (reason.length > 250) return t("move_to_bin_reason_max_chars");
                return null;
            },
        }).then((result) => {
            if (!result.isConfirmed) return;

            dispatch(ejectRfq({ rfq_id: rfqId, reason: result.value.trim() }))
                .unwrap()
                .then((res) => {
                    Toaster.success(res?.message || t("move_to_bin_success"));
                    loadData(1);
                })
                .catch((err) => {
                    Toaster.error(err?.message || t("move_to_bin_failed"));
                });
        });
    };

    return (
        <div className="mt-5 mb-8 flex flex-col gap-8">
            {loading && <ShowLoader />}
            <ScrollToTop />

            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 px-4 md:px-6">
                <div className="flex w-full md:flex-1 items-center">
                    <Typography variant="h5" color="blue-gray" className="font-bold text-xl">
                        {t("title")}
                    </Typography>
                    <button onClick={forceReloadRfq} className="ml-4">
                        <img src="/img/icons/reload.png" alt='Reload' className={`h-4 w-4 ${isSpinning1 ? "animate-spin" : ""}`} />
                    </button>
                </div>

                <div className="w-full md:flex-1 flex justify-center">
                    <div className="w-full relative">
                        <Input
                            label={ct("search")}
                            className={search ? "ltr:pr-10 rtl:pl-10" : ""}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyUp={handelSearch}
                        />
                        {!search && (
                            <MagnifyingGlassIcon
                                aria-hidden="true"
                                className="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-blue-gray-500 ltr:right-3 rtl:left-3"
                            />
                        )}
                        {search && (
                            <IconButton variant="text" size="sm" className="!absolute top-1 ltr:right-1 rtl:left-1" onClick={handelRemoveSearch}>
                                <XCircleIcon className="h-5 w-5 text-red-500" />
                            </IconButton>
                        )}
                    </div>
                    {search && (
                        <Button variant="outlined" className="flex items-center border-gray-300 capitalize font-bold bg-black text-white mx-2" onClick={handleSearchClick}>
                            {t("search_button")}
                        </Button>
                    )}
                </div>

                {user?.roles?.[0] !== 'Sales Representative' && (
                    <div className="pl-0 md:pl-6">
                        <RfqTypeSelector />
                    </div>
                )}
            </div>

            {/* Tab Toggle (Normal vs Custom) */}
            <div className="px-4 md:px-6">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">


                    {/* <div className="flex bg-gray-100 w-fit rounded-2xl p-1 shadow-sm gap-2">
                        <button
                            onClick={() => setActiveTab("normal")}
                            className={`relative text-sm font-normal px-6 py-2 rounded-2xl transition-all duration-300 z-10 ${activeTab === "normal" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                        >
                            {t("normal_rfq_tab")}
                        </button>
                        <button
                            onClick={() => setActiveTab("custom")}
                            className={`relative text-sm font-normal px-6 py-2 rounded-2xl transition-all duration-300 z-10 ${activeTab === "custom" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                        >
                            {t("custom_rfq_tab")}
                        </button>
                    </div> */}
                    <div className="flex bg-gray-100 w-fit rounded-2xl p-1 shadow-sm gap-2">
                        <button
                            onClick={() => setActiveTab("normal")}
                            className={`relative text-sm font-normal px-6 py-2 rounded-2xl transition-all duration-300 z-10 ${activeTab === "normal" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                        >
                            <span className="relative inline-block">
                                {t("normal_rfq_tab")}
                                {hasUnreadNormal && (
                                    <span className="absolute -top-1 -right-3 flex h-2 w-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                    </span>
                                )}
                            </span>
                        </button>
                        <button
                            onClick={() => setActiveTab("custom")}
                            className={`relative text-sm font-normal px-6 py-2 rounded-2xl transition-all duration-300 z-10 ${activeTab === "custom" ? "text-white bg-black" : "text-gray-700 hover:text-black"}`}
                        >
                            <span className="relative inline-block">
                                {t("custom_rfq_tab")}
                                {hasUnreadCustom && (
                                    <span className="absolute -top-1 -right-3 flex h-2 w-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                    </span>
                                )}
                            </span>
                        </button>
                    </div>
                    <div className="flex flex-wrap gap-3">
                        {ownerCards.map((card) => (
                            <button
                                key={card.key}
                                onClick={() => setCurrentOwnerFilter(card.key)}
                                className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition-all duration-200 hover:shadow-md min-w-[170px]
                            ${card.bg} ${card.border}
                            ${currentOwnerFilter === card.key ? 'ring-2 ring-black/20 scale-[1.02]' : ''}
                        `}
                            >
                                <div className="text-2xl">{card.icon}</div>

                                <div className="text-left">
                                    <div className={`text-sm font-semibold ${card.text}`}>
                                        {card.label}
                                    </div>
                                    <div className="text-xl font-bold text-gray-900">
                                        {card.count}
                                    </div>
                                </div>
                            </button>
                        ))}

                        {/* Optional: clear filter */}
                        {currentOwnerFilter && (
                            <button
                                onClick={() => setCurrentOwnerFilter('')}
                                className="px-3 py-2 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50"
                            >
                                {t("clear")}
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Actions Bar */}
            <div className="flex flex-row justify-between items-center px-0 xl:px-6 w-full max-w-[1000px] xl:max-w-full overflow-x-auto">
                <div className="flex items-center gap-4 shrink-0 pr-2 xl:pr-0">
                    {/* {hasDeletePermission && ( */}
                    {hasDeletePermission && (filter === 'archived' || filter === 'bin') && (
                        <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer" onChange={handleCheckAll} checked={isAllChecked} />
                    )}
                    {/* <button onClick={reloadRfq}>
                        <img src="/img/icons/reload.png" alt='Reload' className={`h-4 w-4 ${isSpinning2 ? "animate-spin" : ""}`} />
                    </button> */}
                </div>

                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2 bg-[#EBE9E6] px-3 py-2 rounded-lg">

                        <CalendarDaysIcon className="h-5 w-5 text-gray-700" />

                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="bg-transparent outline-none text-sm"
                        />

                        <span className="text-gray-500 text-sm">to</span>

                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="bg-transparent outline-none text-sm"
                        />

                        {(startDate || endDate) && (
                            <XCircleIcon
                                className="h-5 w-5 text-red-500 cursor-pointer"
                                onClick={() => {
                                    setStartDate('');
                                    setEndDate('');
                                }}
                            />
                        )}
                    </div>
                    <Popover
                        isOpen={isQuotationPopoverOpen}
                        positions={["bottom"]}
                        onClickOutside={() => setIsQuotationPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-56 border border-gray-100 py-2">

                                {quotationOptions.map((item) => (

                                    <button
                                        key={item.value}
                                        onClick={() => {
                                            setQuotationStatus(item.value);
                                            setIsQuotationPopoverOpen(false);
                                        }}
                                        className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${quotationStatus === item.value
                                            ? "bg-gray-100 font-semibold"
                                            : ""
                                            }`}
                                    >
                                        {item.label}
                                    </button>

                                ))}

                            </div>
                        }
                    >

                        <Button
                            onClick={() => setIsQuotationPopoverOpen(!isQuotationPopoverOpen)}
                            variant="outlined"
                            className="flex items-center gap-2 bg-[#EBE9E6] border-none text-gray-800 capitalize"
                        >
                            <Bars3BottomLeftIcon className="h-4 w-4" />
                            {
                                quotationOptions.find(opt => opt.value === quotationStatus)?.label || t("quotation_status_filter")
                            }
                        </Button>

                    </Popover>
                    <Popover
                        isOpen={isSortingPopoverOpen}
                        positions={["bottom"]}
                        onClickOutside={() => setIsSortingPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-56 flex flex-col z-50 py-1 border border-gray-100">

                                {/* Sort section */}
                                <p className="px-3 pt-2 pb-1 text-[11px] font-semibold text-gray-400 uppercase">{t("sort_section_label")}</p>
                                <button
                                    onClick={() => { handelSorting(""); setMyStatusFilter(""); }}
                                    className={`text-left text-sm px-3 py-2 hover:bg-gray-100 ${!myStatusFilter && sortingOrder === '' ? 'bg-gray-50 font-semibold' : ''}`}
                                >
                                    {t("sort_latest")}
                                </button>
                                {sorting_options.map((opt) => (
                                    <button
                                        key={opt.value}
                                        onClick={() => { handelSorting(opt.value); setMyStatusFilter(""); }}
                                        className={`text-left text-sm px-3 py-2 hover:bg-gray-100 ${!myStatusFilter && sortingOrder === opt.value ? 'bg-gray-50 font-semibold' : ''}`}
                                    >
                                        {opt.label}
                                    </button>
                                ))}

                                {/* Divider */}
                                <div className="border-t border-gray-100 my-1" />

                                {/* My Status section */}
                                <p className="px-3 pt-1 pb-1 text-[11px] font-semibold text-gray-400 uppercase">{t("my_status_section_label")}</p>
                                {myStatusOptions.map((opt) => {
                                    // "rejected" doesn't make sense on tabs that already imply full approval
                                    const isDisabled = opt.value === 'rejected' && (filter === 'assigned' || filter === 'unassigned');

                                    return (
                                        <button
                                            key={opt.value}
                                            disabled={isDisabled}
                                            onClick={() => {
                                                if (isDisabled) return;
                                                setMyStatusFilter(opt.value === myStatusFilter ? "" : opt.value);
                                                setIsSortingPopoverOpen(false);
                                            }}
                                            className={`text-left text-sm px-3 py-2 hover:bg-gray-100 ${myStatusFilter === opt.value ? 'bg-gray-50 font-semibold' : ''} ${isDisabled ? 'opacity-40 cursor-not-allowed' : ''}`}
                                        >
                                            {opt.label}
                                        </button>
                                    );
                                })}
                            </div>
                        }
                    >
                        <Button onClick={() => setIsSortingPopoverOpen(!isSortingPopoverOpen)} variant="outlined" className="flex items-center gap-2 bg-[#EBE9E6] border-none text-gray-800 capitalize">
                            <Bars3BottomLeftIcon className="h-4 w-4" />
                            <span className="text-sm">{getSortButtonLabel()}</span>
                        </Button>
                    </Popover>

                    {hasDeletePermission && (filter === 'archived' || filter === 'bin') && (
                        <Popover
                            isOpen={isCheckedItemPopoverOpen}
                            positions={["bottom"]}
                            onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                            content={
                                <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                    {action_options.map((opt) => (
                                        <button key={opt.value} onClick={() => handelCheckedItems(opt.value)} className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize">{opt.label}</button>
                                    ))}
                                </div>
                            }
                        >
                            <Button onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)} variant="outlined" className="flex items-center gap-2 bg-black text-white capitalize">
                                {t("selected_items_button")}  <ChevronDownIcon className="h-4 w-4" />
                            </Button>
                        </Popover>
                    )}
                </div>
            </div>

            {/* Sub-tabs (Unassigned / Pending / Assigned) */}
            <div className="flex gap-8 border-b border-gray-100 px-4 md:px-6 pt-2 overflow-x-auto max-[1100px]:overflow-x-visible">
                {tabs.map((t) => (
                    <button
                        key={t.id}
                        onClick={() => setFilter(t.id)}
                        className={`relative pb-2 text-base font-medium transition-all ${filter === t.id ? "border-b-2 border-black text-black" : "text-gray-500"}`}
                    >
                        <span className="relative inline-block">{t.label} {(total_count && total_count[t.id]) ? `(${total_count[t.id]})` : '(0)'}
                            {unread_counts?.[t.id] > 0 && (
                                <span className="absolute -top-1 -right-2 flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                </span>
                            )}
                        </span>
                    </button>
                ))}
            </div>

            {/* Data List Container */}
            <div className="">
                {list_loading && currentPage === 1 && list_rfqs?.length === 0 ? (
                    <div className="flex justify-center py-20"><ShowLoader /></div>
                ) : (
                    <div id="scrollableDiv" className="divide-y divide-gray-100 h-[calc(100vh-350px)] overflow-y-auto">
                        <InfiniteScroll
                            dataLength={list_rfqs?.length || 0}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            scrollableTarget="scrollableDiv"
                            loader={<div className="text-center p-4">{t("loading_more")}</div>}
                            endMessage={list_rfqs?.length == 0 ? <p className="text-center text-gray-400 py-6 text-sm">{t("no_rfqs_found")}</p> : null}
                        >
                            {list_rfqs?.length > 0 && list_rfqs?.map((rfq) => {
                                const totalPrice = rfq?.products?.reduce((sum, item) => sum + (item?.customer_price ? Number(item.customer_price) : Number(item.total_amount) || 0), 0);
                                const isClientRejected = rfq?.quotation_status?.toLowerCase() === "rejected";

                                // const myStatus = getUserWorkflowStatus(rfq);
                                const myStatus = rfq?.workflow_status || { status: "-", colors: { text: "#374151" } };

                                const currentStep = getCurrentStep(rfq);

                                return (
                                    <div
                                        key={rfq.id}
                                        className={`
                                            relative
                                            grid grid-cols-6
                                            w-full
                                            min-w-[1100px]
                                            items-start
                                            gap-4
                                            pt-7
                                            pb-5
                                            border-b
                                            border-[#DBDBDB]
                                            transition-all
                                            duration-300
                                            hover:bg-gray-50

                                            ${isClientRejected
                                                ? "bg-red-50/30"
                                                : ""
                                            }
                                        `}
                                    >
                                        {/* ID & Checkbox */}
                                        <div className="flex items-start gap-3">
                                            {/* {hasDeletePermission && ( */}
                                            {hasDeletePermission && (filter === 'archived' || filter === 'bin') && (
                                                <input type="checkbox" className="w-4 h-4 accent-green cursor-pointer mt-1" onChange={() => handleSingleCheck(rfq.id)} checked={checkedItems.includes(rfq.id)} />
                                            )}
                                            <div className="flex flex-col gap-1">
                                                <div className="flex items-center gap-1.5">
                                                    <Link
                                                        to={`/dashboard/rfqs/${rfq.id}`}
                                                        state={{ from: searchParams.toString() }}
                                                        className="font-bold text-sm text-[#1A1918] hover:text-blue-600 hover:underline cursor-pointer transition">
                                                        {t("rfq_id_prefix")} {String(rfq.id).padStart(4, "0")}
                                                    </Link>
                                                    {rfq?.is_new && (
                                                        <span className="relative flex h-2 w-2">
                                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                                            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                                                        </span>
                                                    )}
                                                </div>
                                                <p className="text-sm text-gray-500 font-medium">{t("ref_id_prefix")} {rfq.rfq_reference}</p>

                                                {rfq?.purchase_order_file && (
                                                    <div className="flex flex-col gap-1">
                                                        <p className="text-sm text-gray-500 font-medium flex items-center gap-2">
                                                            <span>PO : {rfq.purchase_order_number}</span>
                                                            <DocumentArrowDownIcon
                                                                className="h-4 w-4 text-gray-500 cursor-pointer hover:text-blue-600"
                                                                onClick={() => setPOFile(rfq.purchase_order_file)}
                                                            />
                                                        </p>

                                                        {/* Check if there is an approved PO AND a newer pending PO */}
                                                        {(() => {
                                                            const pos = rfq?.purchase_orders || [];
                                                            const hasApprovedPo = pos.some(po => po.status === "approved");
                                                            const hasPendingPo = pos.some(po => po.status === "pending");

                                                            const customerPoCount = pos.filter(
                                                                po => po.purchase_order_file?.uploaded_by === "customer"
                                                            ).length;

                                                            // const isRevisedPo = customerPoCount >= 2 && hasApprovedPo && hasPendingPo;
                                                            const isRevisedPo = customerPoCount >= 2;

                                                            if (isRevisedPo) {
                                                                return (
                                                                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-bold bg-amber-100 text-amber-800 w-fit">
                                                                        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
                                                                        {t("revised_po_badge")}
                                                                    </span>
                                                                );
                                                            }

                                                            return null;
                                                        })()}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Customer Info */}
                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1">
                                                <p className="font-bold text-sm text-[#1A1918]">{rfq?.customer?.company_name || rfq?.guest_customer?.company_name}</p>
                                                {rfq?.alternate_number &&
                                                    <Tooltip content={`${t("alt_phone_tooltip")} ${rfq?.alternate_country_code + " " + rfq?.alternate_number || t("na")}`} className="bg-white text-gray-900 border border-gray-200 shadow-md">
                                                        <InformationCircleIcon className="h-4 w-4 text-gray-400 cursor-pointer" />
                                                    </Tooltip>
                                                }
                                            </div>
                                            <p className="text-sm font-medium text-gray-500 m-0">{rfq?.customer?.country_code || rfq?.guest_customer?.country_code} {rfq?.customer?.mobile_number || rfq?.guest_customer?.mobile_number}</p>
                                        </div>

                                        {/* Items & Location */}
                                        <div className="flex flex-col gap-1">
                                            <p className="font-bold text-sm text-[#1A1918]">{t("items_label")} {rfq?.products?.length || 0}</p>
                                            <p className="text-sm font-medium text-gray-500 truncate">{t("deliver_to_label")} {rfq?.customer?.kyc_details?.permanent_address || rfq?.guest_customer?.permanent_address || t("na")}</p>
                                        </div>

                                        {/* Pricing & Deadline */}
                                        <div className="flex flex-col gap-1">
                                            <p className="text-[#1A1918] font-bold">{rfq?.currency_code} {Math.round((totalPrice || 0) * 100) / 100}</p>                                            {(user?.roles[0] === 'Sub Admin' || user?.roles[0] === 'Administrator' || user?.roles[0] === 'Finance') &&
                                                <p className="text-sm font-medium text-gray-500">
                                                    {t("deadline_label")} {rfq?.assigned_details?.[0]?.deadline ? moment(rfq.assigned_details[0].deadline).format("D MMM | h:mm A") : t("na")}
                                                </p>
                                            }
                                            {(user?.roles[0] !== 'Sub Admin' && user?.roles[0] !== 'Administrator' && user?.roles[0] !== 'Finance') && (
                                                (() => {
                                                    const assigned_user = rfq?.assigned_details?.find((item) => item.assigned_to_id === user?.id) ||
                                                        rfq?.assigned_details?.[0];

                                                    const timeSlotTo = assigned_user?.timeslot?.to;
                                                    const status = getTimeSlotStatus(timeSlotTo);
                                                    return (
                                                        <p className={`text-sm font-medium ${status.color}`}>
                                                            {t("timeslot_label")} {assigned_user?.timeslot?.from ?
                                                                moment(assigned_user.timeslot.from).format("D MMM | h:mm A") + " - " + moment(timeSlotTo).format("D MMM | h:mm A")
                                                                : t("na")
                                                            }
                                                            {status.delayed}
                                                        </p>
                                                    );
                                                })()
                                            )}
                                        </div>

                                        {/* Actions Icons */}
                                        <div className="flex flex-col gap-2 items-center">
                                            {/* Icons */}
                                            <div className="w-20 flex gap-2 justify-center">
                                                <ClockIcon
                                                    className="w-4 h-4 text-gray-500 cursor-pointer hover:text-blue-500"
                                                    onClick={() => setIsTimelineModalOpen(rfq.id)}
                                                />

                                                {filter !== 'archived' && (() => {
                                                    const qStatus = rfq?.quotation_status?.toLowerCase();

                                                    let iconColorClass = "text-gray-500 hover:text-blue-500";
                                                    if (qStatus === "approved") iconColorClass = "text-green-500 hover:text-green-600";
                                                    else if (qStatus === "pending") iconColorClass = "text-yellow-600 hover:text-yellow-700";
                                                    else if (qStatus === "rejected") iconColorClass = "text-red-500 hover:text-red-600";

                                                    const chatLink = (
                                                        <Link to={`/dashboard/rfqs/${rfq.id}`} state={{ active_tab: 'chat' }}>
                                                            <ChatBubbleOvalLeftEllipsisIcon className={`w-4 h-4 transition-colors ${iconColorClass}`} />
                                                        </Link>
                                                    );

                                                    if (qStatus === "rejected" && rfq?.quotation_reject_reason) {
                                                        return (
                                                            <Tooltip
                                                                content={t("quotation_rejected_reason", { reason: rfq.quotation_reject_reason })}
                                                                className="bg-white text-gray-900 border border-gray-200 shadow-md max-w-xs break-words"
                                                            >
                                                                {chatLink}
                                                            </Tooltip>
                                                        );
                                                    }

                                                    return chatLink;
                                                })()}
                                                {(filter === 'unassigned' || filter === 'archived') && (
                                                    <Tooltip
                                                        content={filter === 'unassigned' ? t('archive_rfq_tooltip') : t('unarchive_rfq_tooltip')}
                                                        className="bg-white text-gray-900 border border-gray-200 shadow-md"
                                                    >
                                                        <ArchiveBoxIcon
                                                            className={`w-4 h-4 cursor-pointer transition-colors ${filter === 'archived'
                                                                ? "text-red-500 hover:text-gray-500"
                                                                : "text-gray-500 hover:text-red-500"
                                                                }`}
                                                            onClick={() => handleArchiveRfq(rfq.id, filter === 'unassigned' ? "yes" : "no")}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </div>
                                            {(filter !== 'unassigned' && filter !== 'pending_po_acknowledgement' && filter !== 'archived' && filter !== 'bin') && <>
                                                <div className="w-28 flex items-center justify-center">
                                                    {(() => {
                                                        const dynamicSteps = generateProcessSteps(rfq?.assigned_details, currentStep, rfq);
                                                        const currentStage =
                                                            isWorkflowRejected(rfq)
                                                                ? "rejected"
                                                                : rfq?.admin_approval === "yes"
                                                                    ? "completed"
                                                                    : rfq?.is_send_to_admin
                                                                        ? "admin"
                                                                        :
                                                                        // rfq?.assigned_details?.some(
                                                                        //     (item) => item.type === "Procurement"
                                                                        // )
                                                                        rfq?.is_procurement_assigned === "yes"
                                                                            ? "procurement"
                                                                            : "sales";
                                                        return (
                                                            <Popover
                                                                isOpen={isStatusPopoverOpen === rfq.id}
                                                                positions={["bottom", "top"]}
                                                                padding={10}
                                                                onClickOutside={() => setIsStatusPopoverOpen(false)}
                                                                content={
                                                                    <div className="w-80 rounded-lg border bg-white shadow-lg p-4">
                                                                        {dynamicSteps.map((step, index) => {
                                                                            const stepNumber = index + 1;
                                                                            const isCompleted = step.status === "completed";
                                                                            const isDelayed = step.status === "delayed";
                                                                            const active = currentStep === stepNumber && currentStep <= dynamicSteps.length;
                                                                            const roleColor = stepNumber === 1 ? "sales" : stepNumber === 2 ? "procurement" : "admin";

                                                                            return (
                                                                                <div key={stepNumber} className="flex gap-3 relative pb-4 last:pb-0">
                                                                                    <div className="flex flex-col items-center">
                                                                                        <div
                                                                                            className={`w-4 h-4 rounded-full z-10 ${isCompleted
                                                                                                ? workflowStepColors.completed
                                                                                                : active
                                                                                                    ? isDelayed
                                                                                                        ? workflowStepColors.delayed
                                                                                                        : workflowStepColors[roleColor]
                                                                                                    : workflowStepColors.pending
                                                                                                }`}
                                                                                        />
                                                                                        {/* Vertical connecting line */}
                                                                                        {stepNumber !== dynamicSteps.length && (
                                                                                            <div className="absolute top-4 bottom-[-4px] left-[7px] w-0.5 bg-gray-300" />
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        <p
                                                                                            className={`font-medium text-sm ${isCompleted
                                                                                                ? workflowTextColors.completed
                                                                                                : active
                                                                                                    ? isDelayed
                                                                                                        ? workflowTextColors.delayed
                                                                                                        : workflowTextColors[roleColor]
                                                                                                    : "text-gray-700"
                                                                                                }`}
                                                                                        >
                                                                                            {step.title}
                                                                                        </p>

                                                                                        {/* Conditional Red/Gray Text Description */}
                                                                                        <p className={`text-xs mt-1 ${!isCompleted && isDelayed
                                                                                            ? "text-red-500"
                                                                                            : "text-gray-500"
                                                                                            }`}>
                                                                                            {isCompleted
                                                                                                ? step.completed_description
                                                                                                : isDelayed
                                                                                                    ? step.delayed_description
                                                                                                    : step.pending_description}
                                                                                        </p>

                                                                                        {isCompleted && (
                                                                                            <span className="text-xs text-green-600 font-medium mt-1 inline-block">
                                                                                                {t("completed_step")}
                                                                                            </span>
                                                                                        )}

                                                                                        {active && (
                                                                                            <span
                                                                                                className={`text-xs font-medium mt-1 inline-block ${isDelayed
                                                                                                    ? workflowTextColors.delayed
                                                                                                    : workflowTextColors[roleColor]
                                                                                                    }`}
                                                                                            >
                                                                                                {isDelayed ? t("delayed_step") : t("in_progress_step")}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                }
                                                            >
                                                                <div className={`flex items-center gap-1.5 text-[10px] px-3 py-1 rounded-full font-bold whitespace-nowrap cursor-pointer
                                                                    ${filter === "reassigned"
                                                                        ? "bg-red-100 text-red-700"
                                                                        : filter === "rejected_orders"
                                                                            ? "bg-red-100 text-red-700"
                                                                            : statusColors[currentStage]
                                                                    }`}
                                                                // onClick={() => setIsStatusPopoverOpen(rfq?.id)}
                                                                >
                                                                    <InformationCircleIcon className="h-4 w-4" />
                                                                    <span>
                                                                        {filter === "reassigned"
                                                                            ? t("reassigned_status")
                                                                            : filter === "rejected_orders"
                                                                                ? t("rejected_order_status")
                                                                                : isWorkflowRejected(rfq)
                                                                                    ? t("rejected_status")
                                                                                    : rfq?.admin_approval?.trim() === "yes"
                                                                                        ? t("approved_status")
                                                                                        : t("pending_status")}
                                                                    </span>
                                                                </div>
                                                            </Popover>
                                                        );
                                                    })()}
                                                </div>
                                                {/* <span className={`${myStatus.text}`}>
                                                    {myStatus.status}
                                                </span> */}
                                                <span className="text-[14px] text-center" style={{ color: myStatus?.colors?.text }}>
                                                    {myStatus?.status}
                                                </span>
                                            </>}
                                            {filter === 'pending_po_acknowledgement' && (<>
                                                <span>
                                                    {rfq?.is_po_approved === "yes" ? (
                                                        <span className="flex items-center gap-1.5 text-[14px] px-3 py-1 rounded-full font-bold bg-green-100 text-green-600 cursor-pointer">
                                                            {t("approved_po_status")}
                                                        </span>
                                                    ) : rfq?.is_po_approved === "no" ? (
                                                        <span className="flex items-center gap-1.5 text-[14px] px-3 py-1 rounded-full font-bold bg-red-100 text-red-600 cursor-pointer">
                                                            {t("rejected_po_status")}
                                                        </span>
                                                    ) : (
                                                        <span className="flex items-center gap-1.5 text-[14px] px-3 py-1 rounded-full font-bold bg-yellow-100 text-yellow-600 cursor-pointer">
                                                            {t("pending_po_status")}
                                                        </span>
                                                    )}
                                                </span>
                                                <Popover
                                                    isOpen={openPOPopoverId === rfq.id}
                                                    positions={["bottom"]}
                                                    onClickOutside={() => setOpenPOPopoverId(null)}
                                                    content={
                                                        <div className="bg-white shadow-xl rounded-md w-48 border border-gray-100 py-2">

                                                            <button
                                                                className="w-full flex items-center gap-2 px-4 py-2 text-green-600 hover:bg-green-50"
                                                                onClick={() => {
                                                                    setOpenPOPopoverId(null);
                                                                    handlePOAcknowledgement(rfq.id, "yes");
                                                                }}
                                                            >
                                                                <CheckBadgeIcon className="h-4 w-4" />
                                                                {/* <span>Approve PO</span> */}
                                                                <span>{t("approve_po")}</span>
                                                            </button>

                                                            {rfq?.is_po_approved !== "no" && <button
                                                                className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50"
                                                                onClick={() => {
                                                                    setOpenPOPopoverId(null);
                                                                    handlePOAcknowledgement(rfq.id, "no");
                                                                }}
                                                            >
                                                                <XMarkIcon className="h-4 w-4" />
                                                                {/* <span>Reject PO</span> */}
                                                                <span>{t("reject_po")}</span>
                                                            </button>
                                                            }

                                                        </div>
                                                    }
                                                >
                                                    <p className="flex items-center gap-2 px-2 py-2 bg-gray-200 rounded-xl border border-gray-100 cursor-pointer" onClick={() => setOpenPOPopoverId(
                                                        openPOPopoverId === rfq.id ? null : rfq.id
                                                    )}> <CheckBadgeIcon className="h-4 w-4 text-green-600" /> <XMarkIcon className="h-4 w-4 text-red-600" /></p>
                                                </Popover>
                                            </>
                                            )}
                                        </div>

                                        {/* Dynamic CTA Button */}
                                        <div className="flex flex-col items-center right-0 z-20 bg-[#F5F7F8] shadow-[-8px_0_8px_-6px_rgba(0,0,0,0.1)]">
                                            {filter === 'unassigned' && hasUpdatePermission ? (
                                                <div className="flex flex-wrap items-center justify-center gap-2">
                                                    <button onClick={() => {
                                                        if (rfq?.customer_approval === 'yes') {
                                                            Toaster.error('This quotation has already been approved by the customer. Sales involvement is not required.');
                                                        } else {
                                                            setIsAssignModalOpen(rfq.id)
                                                        }
                                                    }} className="bg-[#F4B320] hover:bg-yellow-500 text-[#1A1918] font-normal px-4 py-1.5 rounded-lg transition">{t("assign_button")}</button>

                                                    {(userRole === 'Administrator' || userRole === 'Sub Admin') && (
                                                        <button
                                                            onClick={() => handleEjectRfq(rfq.id)}
                                                            className="flex items-center gap-1 border border-red-500 text-red-600 hover:bg-red-50 font-normal px-2 py-1.5 rounded-lg transition"
                                                        >
                                                            {t("move_to_bin_button")}
                                                        </button>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="flex -space-x-2">
                                                    {rfq?.assigned_details?.filter(r => r.type !== "customer").map((row, i) => (
                                                        <Tooltip key={i} content={row.assigned_to_name}>
                                                            <img className="w-7 h-7 rounded-full border-2 border-white" src={row.assigned_to_profile_image} alt="User" />
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            )}
                                            <p className="text-gray-500 text-[12px] leading-tight mt-1">{formatReceivedRfqDate(rfq.created_at)}</p>
                                        </div>
                                        {isClientRejected && (
                                            <div
                                                className="
                                                    pointer-events-none
                                                    absolute
                                                    bottom-0
                                                    left-0
                                                    w-full
                                                    h-8
                                                    bg-gradient-to-t
                                                    from-red-300/10
                                                    via-red-200/15
                                                    to-transparent
                                                "
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </InfiniteScroll>
                    </div>
                )}
            </div>

            {/* Modals */}
            {isAssignModalOpen && (
                <AssignSalesManagerModal
                    onClose={() => {
                        setIsAssignModalOpen(false);
                        loadData(1);
                        dispatch(setEmptySalesTeamMember())
                    }}
                    rfqId={isAssignModalOpen}
                />
            )}
            {isTimelineModalOpen && (
                <TimeLineModal
                    isOpen={!!isTimelineModalOpen}
                    onClose={() => setIsTimelineModalOpen(false)}
                    rfqId={isTimelineModalOpen}
                />
            )}
            {isSetPOFile && <DocumentViewModal documentUrl={isSetPOFile} setIsDocumentViewModalOpen={setPOFile}></DocumentViewModal>}

        </div>
    );
}

export default Rfq;
